import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const linkedInUrl =
	"https://www.linkedin.com/in/anu-chaudhary-52ba4310/?originalSubdomain=in";

const TheContextSustainableFinance: React.FC = () => (
	<>
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "400px", sm: "350px" }}
			minH={{ xs: "400px", sm: "350px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDirection="column"
			>
				<Flex
					alignItems={{ xs: "flex-start", md: "flex-start" }}
					justifyContent="center"
					columnGap="24px"
					justifyItems="center"
					width="100%"
					display="flex"
					as="section"
					rowGap="30px"
					flexDir={{
						xs: "column",
						md: "row",
					}}
				>
					<Flex flexDir="column" rowGap="16px">
						<Heading
							color="white"
							fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
							fontWeight="800"
							lineHeight={{ xs: "35px", lg: "83px" }}
						>
							#TheContext
						</Heading>
					</Flex>
					<Box
						w="1.5px"
						h={{ xs: "100%" }}
						bgColor="white"
						display={{ xs: "none", md: "block" }}
					/>
					<Box
						w={{ xs: "70%", sm: "60%" }}
						h="1.5px"
						bgColor="white"
						display={{ xs: "block", md: "none" }}
					/>
					{/*  */}
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Sustainable Finance: Today&apos;s Investments, Tomorrow&apos;s
						Impact
					</Heading>
				</Flex>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
				mb="20px"
			>
				<Flex
					flexDir={{
						xs: "column",
						md: "row",
					}}
					gap="20px"
					alignItems={{
						xs: "center",
						md: "unset",
					}}
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/AnuChaudhary-BwjUoGITxM5L.png"
						alt="Anu Chaudhary"
						width="250px"
						height="250px"
						objectFit="cover"
						borderRadius="50%"
					/>
					<Flex direction="column">
						<Heading
							as="h1"
							fontWeight="800"
							pt="20px"
							variant="reportCardTitle"
							fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
							textAlign={{
								xs: "center",
								md: "left",
							}}
							maxW={{
								xs: "100%",
								md: "120px",
							}}
						>
							Anu Chaudhary
							<Link
								href={linkedInUrl}
								target="_blank"
								display={{ xs: "inline-block", md: "none" }}
								pl="10px"
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Heading>
						<Text
							color="text.mediumBlack"
							maxW={{
								xs: "100%",
								md: "120px",
							}}
							w="100%"
							fontSize="16px"
							lineHeight="22px"
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Partner, Global Head of ESG Consulting, Uniqus
						</Text>

						<Link
							href={linkedInUrl}
							target="_blank"
							display={{
								xs: "none",
								md: "block",
							}}
						>
							<IconButton
								aria-label="linkedin"
								icon={<FaLinkedin size="28px" color="#067acc" />}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Flex>
				</Flex>
			</Box>
			<Box>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						Banks and other financial institutions play an instrumental role in
						the global transition to a sustainable economy. On the one hand,
						through sustainable financing, they have the potential to spur
						innovation, upscale sustainability efforts, and augment
						decarbonization of economies – fostering a mutually beneficial
						environment for them, their clients, and the planet at large.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" pt="8px">
						On the other hand, they must make fundamental assessments across
						their portfolios of the inherent risks of financing sustainable
						transition opportunities. These risks can be mitigated by
						establishing robust and effective frameworks in alignment with
						global best practices. These measures not only help them protect
						against sustainability-related risks but at the same time safeguard
						the wider stakeholder community.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Sustainable finance also emerges from commercial imperatives to
						better manage climate and other sustainability-related risks. In a
						landscape where banks and other financial institutions are
						frequently judged on their environmental sustainability, it is
						crucial to create opportunities in sustainable finance and integrate
						sustainability-related considerations into capital allocation, loan
						sanctioning, portfolio oversight, and reporting.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Using sustainable finance solutions as a strategic tool helps
						expedite decarbonization processes, boosts responsible operations,
						and promotes an economy based on environmental, social, and
						governance (ESG) criteria. In that way, banks and other financial
						institutions contribute significantly to the growth of a sustainable
						global economy. In our recently published report, Uniqus has
						explored the complexities of sustainable finance and the challenges
						and prospects it presents for banks and other financial
						institutions. As significant contributors to sustainable
						development, they must develop a sustainable finance framework and
						incorporate initiatives and processes to harness opportunities and
						mitigate risks in their operations and portfolios. This report gives
						insights into recent developments in the sustainable finance
						ecosystem, including relevant institutional and national policies,
						and the key drivers and robustness of the sustainable finance
						market. Related topics for banks, such as climate transition
						planning and measuring financed emissions, shall be covered in a
						follow-up publication.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" mt="16px" mb="8px">
						To read the full report, click here -
						<Link
							href="https://uniqus.com/wp-content/uploads/2024/05/Sustainable-Finance.pdf"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							Sustainable Finance: Today&apos;s Investments, Tomorrow&apos;s
							Impact
						</Link>
					</Text>
				</Box>
			</Box>
			<Box width="100%" height="2px" bgColor="gray.700" />
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="18px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextSustainableFinance;
